// a notification has bellow properties:
/**
 * @typedef { Object } NotificationStoreItem
 * @property {string} id - unique id
 * @property {string} title - title of the notification
 * @property {string} message - message of the notification
 * @property {string} type - type of the notification
 * @property {string} icon - icon of the notification
 * @property {string} author - author of the notification
 * @property {boolean} notInbox - do not show in inbox
 * @property {boolean} read - is the notification read
 * @property {Date} issueTime - time of the notification (timestamp)
 * @property {Date | null} expTime - time of expiration of the notification (timestamp)
 * @property {boolean} popup - is the notification popup
 * @property {boolean} active - is the notification active
 * @property {Array} actions - actions of the notification
 * @property {string} actions.type - type of the action
 * @property {string} actions.title - title of the action
 * @property {string} actions.args - args of the action
 * @property {Boolean} closeOnClick - args of the action
 * @property {onCloseCallback} [onClose] - callback function on popup close
*/

/**
 * @callback onCloseCallback
 * @param {NotificationStoreItem} notification
 * @returns {void}
 */

// Path: modules/notification/js/notification-item.js
// Compare this snippet from modules/notification/js/store.js:
const templates = {
  system : {
    author : 'System',
    title: '',
    message: '',
    notInbox: true,
    read: true,
    type: 'warning',
    icon: 'bi bi-exclamation-triangle-fill',

  },
  system_confirm :{
    author : 'System',
    title: '',
    message: '',
    notInbox: true,
    read: true,
    type: 'warning',
    icon: 'bi bi-exclamation-triangle-fill',
    actions: [
      {
        type: 'confirm',
        title: 'Yes',
        args: {}
      },
      {
        type: 'decline',
        title: 'No',
        args: {}
      },
    ]
  }
};

export {  
  templates
};